import React from "react"

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const ToastComponent = notify => {
  //   const notifyHandler = () => {
  if (notify === true) toast("Wow so easy!")
  //   }

  return (
    <div>
      {/* <button onClick={notifyHandler}>Notify!</button> */}
      <ToastContainer />
    </div>
  )
}

export default ToastComponent
